<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="departments"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.name`]="{ item }">
              <span
                @click="navigate(item)"
                style="
                  cursor: pointer;
                  color: #4f4584;
                  text-decoration: underline;
                "
                >{{ item.name }}</span
              >
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createDepartment"
        @update="updateDepartment"
        :department="department"
        :edit="editMode"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="department"
      :name="currentItem.name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/department/form.vue";
import searchBar from "@/components/searchBar.vue";
import { departmentHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";
export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      department: {},
      showDialog: false,
      currentItem: {},
      departments: [],
      search: "",
      headers: departmentHeaders,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Departments" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      this.getDepartments();
    },
    async getDepartments() {
      await this.$axios
        .get("departments")
        .then((res) => {
          this.departments = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async createDepartment(data) {
      await this.$axios
        .post("departments", { department: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Department created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateDepartment(data) {
      await this.$axios
        .put("departments/" + data.id, { department: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Department updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      this.updateDepartment({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },

    edit(item) {
      this.department = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.department = {};
      this.currentItem = {};
    },
    showActiveStatus(item) {
      return item?.active ? "Active" : "Inactive";
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const activeStatus = this.showActiveStatus(item);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        activeStatus.toLowerCase().includes(search.toLowerCase())
      );
    },

    navigate(item) {
      this.$router.push({
        path: `/departments/${item.id}`,
        query: {
          name: "departments",
        },
      });
    },
  },
};
</script>

<style></style>
